/**
 * @file tabs 组件的 pane 组件
 */
import {FC, Key, LegacyRef} from 'react';

export interface TabPaneProps {
     key: Key;
     className?: string;
     tab: string [];
     tabSpan?: number;
     forwardRef?: LegacyRef<HTMLDivElement>;
     extInfo?: Record<string, any>;
 }

const TabPane: FC<TabPaneProps> = ({className, forwardRef, children}) => (
    <div
        className={className}
        ref={forwardRef}
    >
        {children}
    </div>
);

export default TabPane;

